import React, { useEffect, useState } from "react";
// ANT DESIGN COMPONENTS
import { Breadcrumb } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import {
  updateOrganizationRefreshTable,
  updateOrganizationBreadcrumb,
} from "../../../redux/organizations/organizationSlice";
// INTERFACE
import { OrganizationBreadcrumbInterface } from "../../../interfaces/Organizations.interface";
import { RootState } from "../../../app/store";

function OrganizationBreadcrumb() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [items, setItems] = useState<OrganizationBreadcrumbInterface[]>([]);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { organizationBreadcrumb } = useSelector((state: RootState) => state.organization);

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const updateBreadCrumb = (data: any) => {
    const index = organizationBreadcrumb.findIndex(
      (item: OrganizationBreadcrumbInterface) => item.name === data.target.innerText,
    );
    if (index >= 0) {
      dispatch(updateOrganizationBreadcrumb(organizationBreadcrumb.slice(0, index + 1)));
    }
  };

  const onClickReloadPage = () => {
    dispatch(updateOrganizationRefreshTable(true));
    setTimeout(() => {
      dispatch(updateOrganizationRefreshTable(false));
    }, 1000);
  };

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    if (organizationBreadcrumb) {
      setItems(organizationBreadcrumb);
    }
  }, [organizationBreadcrumb]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Breadcrumb>
      <Breadcrumb.Item>{t("header.organizationManagement")}</Breadcrumb.Item>
      <Breadcrumb.Item
        className={
          items.length === 0
            ? "generalStyles__breadcrumbItem"
            : "generalStyles__breadcrumbItemInactive"
        }
        onClick={onClickReloadPage}
      >
        {t("header.organizations")}
      </Breadcrumb.Item>
      {items.map((item: OrganizationBreadcrumbInterface, index: number) => (
        <Breadcrumb.Item
          onClick={updateBreadCrumb}
          key={item.orgId}
          className={
            index === items.length - 1
              ? "generalStyles__breadcrumbItem"
              : "generalStyles__breadcrumbItemInactive"
          }
        >
          {item.name}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
}

export default OrganizationBreadcrumb;
